import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AuthorizationDataType } from "../common/models/AuthModel";
import { MenuItemData, UserMenuData } from "../utilities/menus/MenuStruct";
import { UserItemData } from "../pages/settings/users/core/_model";
import { NotificationModel } from "../common/models/NotificationModel";

type AppState = {
  appLoading: boolean;
  setAppLoading: (loading: boolean) => void;
  isConnected: boolean;
  setIsConnected: (status: boolean) => void;
  authorizationData: AuthorizationDataType | null;
  setAuthorizationData: (authData: AuthorizationDataType | null) => void;
  resetAuthorizationData: () => void;
  menus: UserMenuData | null;
  setMenus: (menus: UserMenuData | null) => void;
  openMenu: boolean;
  setOpenMenu: (open: boolean) => void;
  activeMenu: MenuItemData | null;
  setActiveMenu: (active: MenuItemData | null) => void;
  showMenuChild: MenuItemData | null;
  setShowMenuChild: (menuChild: MenuItemData | null) => void;
  allAccess: UserMenuData | null;
  setAllAccess: (access: UserMenuData | null) => void;
  userInfos: UserItemData | null;
  setUserInfos: (ui: UserItemData | null) => void;
  notifications: Array<NotificationModel>;
  setNotifications: (notifs: Array<NotificationModel>) => void;
};

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      appLoading: true,
      setAppLoading: (loading) => set((state) => ({ appLoading: loading })),
      isConnected: false,
      setIsConnected: (status) => set((state) => ({ isConnected: status })),
      authorizationData: null,
      setAuthorizationData: (authData) =>
        set(() => ({ authorizationData: authData })),
      resetAuthorizationData: () => set(() => ({ authorizationData: null })),
      menus: null,
      setMenus: (menus) => set((state) => ({ menus })),
      openMenu: true,
      setOpenMenu: (open) => set((state) => ({ openMenu: open })),
      activeMenu: null,
      setActiveMenu: (active) => set((state) => ({ activeMenu: active })),
      showMenuChild: null,
      setShowMenuChild: (menuChild) =>
        set((state) => ({ showMenuChild: menuChild })),
      allAccess: null,
      setAllAccess: (access) => set((state) => ({ allAccess: access })),
      userInfos: null,
      setUserInfos: (ui) => set((state) => ({ userInfos: ui })),
      notifications: [],
      setNotifications: (ntfs) => set((state) => ({ notifications: ntfs })),
    }),
    {
      name: "auth_data",
      partialize: (state) => ({
        authorizationData: state.authorizationData,
      }),
    }
  )
);

export default useAppStore;
